var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarthLocate = function SvgEarthLocate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.29 22.963a11.2 11.2 0 1 1 8.661-13.31m-17.92 11.12.996-5.027h1.075a1.47 1.47 0 0 0 1.175-.578 1.43 1.43 0 0 0 .268-1.274L7.8 10.907a1.48 1.48 0 0 0-1.444-1.135H1.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.96 5.292h-4.062a1.48 1.48 0 0 0-1.443 1.135l-.648 2.599m3.913 2.24a4.47 4.47 0 0 1 4.48 4.48c0 1.911-2.678 5.555-3.893 7.108a.747.747 0 0 1-1.174 0c-1.215-1.553-3.893-5.197-3.893-7.108a4.47 4.47 0 0 1 4.48-4.48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M18.725 16.124a.373.373 0 1 1 0-.747m0 .747a.373.373 0 0 0 0-.747"
  })));
};
export default SvgEarthLocate;